export default __webpack_public_path__ + "static/media/yo_7.5a120906.mp3";